import { render, staticRenderFns } from "./AdminCreate.vue?vue&type=template&id=0d25c314"
import script from "./AdminCreate.vue?vue&type=script&lang=js"
export * from "./AdminCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports